<template>
  <b-tab title="Geral" active>
    <b-card-group deck>
      <b-card no-body class="shadow-none" body-class="card-body-class" :content="activeUsers" @update:content="$emit('update:activeUsers', $event)">
        <b-card-header  header-tag="header" header-class="card-header-class" class="d-flex justify-content-center align-items-center">
          <h3>Usuários ativos</h3>
        </b-card-header>
        <b-card-body body-class="card-body-class" v-text="activeUsers"/>
      </b-card>
      <b-card no-body class="shadow-none" body-class="card-body-class" :content="inactiveUsers" @update:content="$emit('update:inactiveUsers', $event)">
        <b-card-header  header-tag="header" header-class="card-header-class" class="d-flex justify-content-center align-items-center">
          <h3>Usuários inativos</h3>
        </b-card-header>
        <b-card-body body-class="card-body-class" v-text="inactiveUsers"/>
      </b-card>
    </b-card-group>
    <b-card-group deck class="card-queues">
      <b-card no-body class="shadow-none" body-class="card-body-class">
        <b-card-header header-tag="header" header-class="card-header-class"
          class="d-flex justify-content-center align-items-center">
          <h3>Filas</h3>
        </b-card-header>
        <b-card-body body-class="card-body-class" class="queue-card-body">
          <b-form-radio-group v-model="queue" class="mr-3 queue-card-form" stacked>
            <b-form-input type="text" v-model="newQueueLabel" min="2" placeholder="Nome da fila"></b-form-input>
            <b-button type="submit" @click="onSubmitQueueForm" >Criar nova fila</b-button>
          </b-form-radio-group>
          <b-table ref="queueTable" striped :fields="fields" :current-page="currentPage" :items="queues" :per-page="0" stacked="md">
          </b-table>
        </b-card-body>
      </b-card>
    </b-card-group>
    <b-card-group deck class="card-una-tokens">
      <b-card no-body class="shadow-none" body-class="card-body-class">
        <b-card-header header-tag="header" header-class="card-header-class"
          class="d-flex justify-content-center align-items-center">
          <h3>Tokens de integração UNA</h3>
        </b-card-header>
        <b-card-body body-class="card-body-class" class="una-token-card-body">
          <b-form class="una-token-form" @submit.stop.prevent="onSubmitUnaIntegrationTokenForm">
            <b-form-input type="text" v-model="integrationTokenName" placeholder="Nome do token"></b-form-input>
            <b-form-select v-model="integrationTokenExpirationMode" :options="expirationOptions"></b-form-select>
            <b-form-input
              v-if="integrationTokenExpirationMode === 'date'"
              type="date"
              v-model="integrationTokenExpiresAt">
            </b-form-input>
            <b-button type="submit">Criar token</b-button>
          </b-form>
          <b-alert :show="!!createdIntegrationToken" variant="success" dismissible @dismissed="createdIntegrationToken = ''">
            <b-form-input readonly :value="createdIntegrationToken"></b-form-input>
          </b-alert>
          <b-input-group class="una-token-remove">
            <b-form-select v-model="selectedIntegrationTokenId" :options="integrationTokenOptions"></b-form-select>
            <b-input-group-append>
              <b-button variant="danger" @click="onRemoveUnaIntegrationToken">Remover token</b-button>
            </b-input-group-append>
          </b-input-group>
          <b-table striped :fields="integrationTokenFields" :items="integrationTokens" :per-page="0" stacked="md">
            <template v-slot:cell(status)="row">
              {{ formatIntegrationTokenStatus(row.item) }}
            </template>
            <template v-slot:cell(expiresAt)="row">
              {{ formatDate(row.item.expiresAt, 'Ilimitado') }}
            </template>
            <template v-slot:cell(lastUsedAt)="row">
              {{ formatDate(row.item.lastUsedAt, '-') }}
            </template>
          </b-table>
        </b-card-body>
      </b-card>
    </b-card-group>
  </b-tab>
</template>

<script>
  import { userService } from '../../services/user_service';

  export default {
    data () {
      return {
        activeUsers: 0,
        inactiveUsers: 0,
        isLoading: false,
        isAdmin: false,
        teste: '',
        queue: '',
        newQueueValue: '',
        newQueueLabel: '',
        queues: [],
        fields: [
          { key: 'label', label: 'Nome', sortable: false },
          { key: 'pendingQueues', label: 'Pendentes', sortable: true, thStyle: { width: '250px' } },
          { key: 'queueLength', label: 'Total', sortable: true, thStyle: { width: '250px' } }
        ],
        integrationTokens: [],
        selectedIntegrationTokenId: null,
        integrationTokenName: '',
        integrationTokenExpirationMode: 'unlimited',
        integrationTokenExpiresAt: '',
        createdIntegrationToken: '',
        expirationOptions: [
          { value: 'unlimited', text: 'Ilimitado' },
          { value: 'date', text: 'Data de expiração' }
        ],
        integrationTokenFields: [
          { key: 'name', label: 'Nome', sortable: true },
          { key: 'tokenPrefix', label: 'Prefixo', sortable: false },
          { key: 'status', label: 'Status', sortable: false },
          { key: 'expiresAt', label: 'Validade', sortable: true },
          { key: 'lastUsedAt', label: 'Último uso', sortable: true }
        ],
        users: [],
        totalRows: 1,
        adminInfoLoaded: false,
        perPage: 15,
        currentPage: 1
      };
    },
    computed: {
      integrationTokenOptions () {
        const options = this.integrationTokens
          .filter(token => token.active && !token.revokedAt)
          .map(token => ({
            value: token.id,
            text: `${token.name} (${token.tokenPrefix})`
          }));
        return [{ value: null, text: 'Selecione um token' }].concat(options);
      }
    },
    async mounted () {
      await this.loadUserAdminInfo({ perPage: parseInt(this.perPage), currentPage: parseInt(this.currentPage) });
      this.queues = await userService.getQueuePriorityInfos();
      await this.loadUnaIntegrationTokens();
      this.adminInfoLoaded = true;
    },
    async created () {
    },
    methods: {
      async loadUserAdminInfo (params) {
        this.isLoading = true;
        const result = await userService.userAdminInfo(params);
        if (result && result.length > 0) {
          this.isAdmin = true;
          this.activeUsers = result[1] ? result[1].active : this.activeUsers;
          this.inactiveUsers = result[2] ? result[2].nonActive : this.inactiveUsers;
          this.users = result[0].elements;
          this.pageInfo = result[0].pageInfo;
          this.totalRows = this.pageInfo && this.pageInfo.length > 0 && this.pageInfo[0].count;
        }
        this.isLoading = false;
      },
      async onSubmitQueueForm () {
        if (this.newQueueLabel < 2) {
          return;
        }
        const newQueueLabelAlredyExists = this.queues.find(queue => queue.label.toLowerCase() === this.newQueueLabel.toLowerCase());
        if (newQueueLabelAlredyExists) {
          return;
        }
        this.newQueueValue = 'STT_' + this.newQueueLabel.replace(/[^a-zA-Z0-9\s]/g, '').toUpperCase();
        const newQueue = {};
        Object.assign(newQueue, { value: this.newQueueValue });
        Object.assign(newQueue, { label: this.newQueueLabel });
        await userService.createQueuePriority(newQueue);

        this.newQueueLabel = '';
        this.queues = await userService.getQueuePriority();
      },
      async loadUnaIntegrationTokens () {
        this.integrationTokens = await userService.unaIntegrationTokens() || [];
        const selectedToken = this.integrationTokens.find(token => token.id === this.selectedIntegrationTokenId);
        if (!selectedToken) {
          this.selectedIntegrationTokenId = null;
        }
      },
      async onSubmitUnaIntegrationTokenForm () {
        if (!this.integrationTokenName) {
          this.$toast.open({ message: 'Informe o nome do token', type: 'error' });
          return;
        }
        if (this.integrationTokenExpirationMode === 'date' && !this.integrationTokenExpiresAt) {
          this.$toast.open({ message: 'Informe a data de expiração', type: 'error' });
          return;
        }

        const tokenInfo = {
          name: this.integrationTokenName,
          expiresAt: this.integrationTokenExpirationMode === 'date' ? this.getEndOfDayTimestamp(this.integrationTokenExpiresAt) : null
        };
        const createdToken = await userService.unaIntegrationTokenRegister(tokenInfo);
        this.createdIntegrationToken = createdToken.token;
        this.integrationTokenName = '';
        this.integrationTokenExpirationMode = 'unlimited';
        this.integrationTokenExpiresAt = '';
        await this.loadUnaIntegrationTokens();
      },
      async onRemoveUnaIntegrationToken () {
        if (!this.selectedIntegrationTokenId) {
          this.$toast.open({ message: 'Selecione um token', type: 'error' });
          return;
        }

        await userService.unaIntegrationTokenRemove(this.selectedIntegrationTokenId);
        this.selectedIntegrationTokenId = null;
        await this.loadUnaIntegrationTokens();
      },
      formatIntegrationTokenStatus (token) {
        if (!token.active || token.revokedAt) {
          return 'Removido';
        }
        if (token.expiresAt && token.expiresAt <= Math.floor(Date.now() / 1000)) {
          return 'Expirado';
        }
        return 'Ativo';
      },
      formatDate (date, emptyText) {
        if (!date) {
          return emptyText;
        }
        const numericDate = Number(date);
        const parsedDate = Number.isFinite(numericDate) ? new Date(numericDate * 1000) : new Date(date);
        if (Number.isNaN(parsedDate.getTime())) {
          return emptyText;
        }
        return parsedDate.toLocaleString('pt-BR');
      },
      getEndOfDayTimestamp (date) {
        const endOfDay = new Date(`${date}T23:59:59`);
        return Math.floor(endOfDay.getTime() / 1000);
      }

    }
  };
</script>

<style>
.card-queues {
  padding-top: 20px;
}

.card-una-tokens {
  padding-top: 20px;
}

.queue-card-body {
  display: flex;
  flex-direction: column;
  gap: 30px
}

.una-token-card-body {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.queue-card-form {
  display: flex;
  gap: 15px;
  width: 100%;
}

.una-token-form {
  display: grid;
  gap: 15px;
  grid-template-columns: minmax(180px, 1fr) 180px 180px 180px;
  width: 100%;
}

.una-token-remove {
  max-width: 520px;
}

.queue-card-form button {
  width: 350px;
}

.una-token-form button {
  width: 180px;
}

@media (max-width: 900px) {
  .una-token-form {
    grid-template-columns: 1fr;
  }

  .una-token-form button {
    width: 100%;
  }
}

</style>
